import httpRequest from '@/utils/request'

export function fetch(query) {
  return httpRequest({
    url: 'addresses',
    method: 'get',
    params: query
  })
}

export function find(id) {
  return httpRequest({
    url: `addresses/${parseInt(id)}`,
    method: 'get'
  })
}

export function save(item) {
  const method = item.id ? 'put' : 'post'
  return httpRequest({
    url: `addresses${item.id ? '/' + parseInt(item.id) : ''}`,
    method,
    data: item
  })
}

export function destroy(id) {
  return httpRequest({
    url: `addresses/${parseInt(id)}`,
    method: 'delete'
  })
}


